<template>
  <v-alert
    class="text-left"
    transition="fade-transition"
    :color="alert.ok? 'success':'error'"
    :type="alert.ok? 'success':'error'"
    text
    v-if="message && message.length > 0"
  >{{message}}</v-alert>
</template>

<script>
export default {
  name: "AAlert",
  props: ["alert", "errorOnly"],
  computed: {
    message: function() {
      if (this.alert) {
        if ((this.errorOnly && !this.alert.ok) || !this.errorOnly) {
          return this.alert.ok ? this.alert.message : this.alert.error;
        }        
      }
      return "";
    }
  }
};
</script>